import { IAppState } from '../../../redux';
import { selectAddressEditingRestrictionData } from './selectAddressEditingRestrictionData';
import { selectConfigValue } from '../../config';

export const selectIsAddressEditingWarningVisible = (state: IAppState): boolean => {
  const editingRestrictionData = selectAddressEditingRestrictionData(state);

  const isRestrictionDataNotAvailable = !editingRestrictionData;
  const isMaxDaysAvailable = !!selectConfigValue('maxAddressEditingDays')(state);

  return isRestrictionDataNotAvailable && isMaxDaysAvailable;
};
